'use strict';
function startMatcha(host, root, config) {
  const byId = id => root.getElementById(id);
  const lifecycle = new AbortController();
  let adding=false, cartUncertain=false, savedOverflow, mobileObserver;
  const apiRoot = config.rootUrl.endsWith('/') ? config.rootUrl : config.rootUrl+'/';
  const allProducts = () => [...Object.values(catalog.bases),...catalog.charms,...catalog.elements,catalog.kitDivine];
  const productRequests = new Map();
  const state = {leftDiameter:25, rightDiameter:40, finish:'gold', left:null, right:null, target:'left', elements:{left:{},right:{}}, kit:{enabled:false,placement:'both'}};
  let catalog;
  const charmsById = new Map();
  const elementsById = new Map();
  const photoRequests = new Map();
  const picker = {theme:null,query:'',page:0};
  const pageSize = 12;
  let pickerOpener;
  const normalize = text => text.normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/œ/g,'oe').replace(/Œ/g,'oe').toLocaleLowerCase('fr').trim();
  const finishName = () => state.finish === 'gold' ? 'dorée' : 'argentée';
  const diameterFor = ear => state[`${ear}Diameter`];
  const pairMode = () => state.leftDiameter === state.rightDiameter ? `${state.leftDiameter}-${state.rightDiameter}` : '25-40';
  const pairText = () => state.leftDiameter === state.rightDiameter ? `2 × ${state.leftDiameter} mm` : '1 × 25 mm + 1 × 40 mm';
  const money = cents => cents===null ? '—' : new Intl.NumberFormat('fr-FR',{style:'currency',currency:catalog.commerce.currency}).format(cents/100);
  const baseKey = ear => `${diameterFor(ear)}-${state.finish}`;
  const selectedElements = ear => Object.entries(state.elements[ear]).filter(([,quantity])=>quantity>0).map(([id,quantity])=>({id,name:elementsById.get(id).name,image:elementsById.get(id).image,quantity}));
  const elementText = ear => selectedElements(ear).map(item=>`${item.name} × ${item.quantity}`).join(' + ');
  const elementCount = () => ['left','right'].reduce((total,ear)=>total+selectedElements(ear).reduce((n,item)=>n+item.quantity,0),0);
  const kitPlacementName = () => ({both:'À répartir sur les deux oreilles',left:`Oreille gauche · ${diameterFor('left')} mm`,right:`Oreille droite · ${diameterFor('right')} mm`})[state.kit.placement];
  function pricing() {
    const lines=new Map();
    const add=(product,quantity)=>{
      const current=lines.get(product.variantId);
      if(current) current.quantity+=quantity;
      else lines.set(product.variantId,{variantId:product.variantId,name:product.fullName || product.name,quantity,unitPriceCents:product.priceCents});
    };
    for(const ear of ['left','right']) {
      add(catalog.bases[baseKey(ear)],1);add(charmsById.get(state[ear]),1);
      for(const item of selectedElements(ear)) add(elementsById.get(item.id),item.quantity);
    }
    if(state.kit.enabled) add(catalog.kitDivine,1);
    const items=[...lines.values()].map(line=>({...line,totalPriceCents:line.unitPriceCents===null?null:line.unitPriceCents*line.quantity}));
    return {currency:catalog.commerce.currency,totalCents:items.some(line=>line.totalPriceCents===null)?null:items.reduce((n,line)=>n+line.totalPriceCents,0),lines:items,capturedAt:catalog.commerce.capturedAt};
  }
  function compositionNote() {
    return ['Composition Matcha Bijoux',`Créoles : ${pairText()}, finition ${finishName()}`,...['left','right'].map(ear=>`${ear==='left'?'Gauche':'Droite'} : créole ${diameterFor(ear)} mm + ${charmsById.get(state[ear]).fullName} × 1${elementText(ear)?' + '+elementText(ear):''}`),...(state.kit.enabled?[`Kit Divine : 1 kit doré · ${kitPlacementName()}`]:[])].join('\n');
  }
  function cartUrl() { return new URL(config.cartUrl,location.origin).href; }
  function selectedProducts() {
    const selected=[];
    for(const ear of ['left','right']) {
      selected.push(catalog.bases[baseKey(ear)],charmsById.get(state[ear]));
      for(const item of selectedElements(ear))selected.push(elementsById.get(item.id));
    }
    if(state.kit.enabled)selected.push(catalog.kitDivine);
    return [...new Map(selected.map(product=>[product.variantId,product])).values()];
  }
  function selectionAvailable() { return selectedProducts().every(product=>product.available===true && Number.isSafeInteger(product.priceCents)); }
  async function jsonRequest(url,options={}) {
    const abort=new AbortController();
    const stop=()=>abort.abort();lifecycle.signal.addEventListener('abort',stop,{once:true});
    const timeout=setTimeout(stop,15000);
    try {
      const response=await fetch(url,{credentials:'same-origin',cache:'no-store',...options,signal:abort.signal});
      if(!response.ok)throw new Error('Réponse Shopify indisponible.');
      return await response.json();
    } finally {clearTimeout(timeout);lifecycle.signal.removeEventListener('abort',stop);}
  }
  async function refreshProduct(product,force=false) {
    if(force)productRequests.delete(product.handle);
    let request=productRequests.get(product.handle);
    if(!request) {
      request=jsonRequest(apiRoot+'products/'+encodeURIComponent(product.handle)+'.js');
      productRequests.set(product.handle,request);
    }
    try {
      const live=await request;
      const variant=live.variants?.find(variant=>variant.id===product.variantId);
      if(!variant||!Number.isSafeInteger(variant.price)||variant.price<0)throw new Error('Variante indisponible.');
      product.priceCents=variant.price;product.available=variant.available===true;product.connectionError=false;
    } catch(_) {
      product.priceCents=null;product.available=false;product.connectionError=true;productRequests.delete(product.handle);
    }
  }
  async function refreshProducts(products,force=false,onProgress=()=>{}) {
    let cursor=0,done=0;
    await Promise.all(Array.from({length:Math.min(6,products.length)},async()=>{
      while(cursor<products.length) {
        const product=products[cursor++];await refreshProduct(product,force);onProgress(++done,products.length);
      }
    }));
  }
  function cartItems(compositionId) {
    const allocations=new Map();
    const allocate=(product,quantity,ear)=>{
      const values=allocations.get(product.variantId)||[];
      values.push(`${ear==='left'?'Gauche':'Droite'} · ${diameterFor(ear)} mm × ${quantity}`);allocations.set(product.variantId,values);
    };
    for(const ear of ['left','right']) {
      allocate(catalog.bases[baseKey(ear)],1,ear);allocate(charmsById.get(state[ear]),1,ear);
      for(const item of selectedElements(ear))allocate(elementsById.get(item.id),item.quantity,ear);
    }
    if(state.kit.enabled)allocations.set(catalog.kitDivine.variantId,[kitPlacementName()]);
    return pricing().lines.map(line=>({id:line.variantId,quantity:line.quantity,properties:{
      'Paire':`${pairText()} · ${finishName()}`,
      'Placement':allocations.get(line.variantId).join(' / '),
      '_matcha_composition':compositionId
    }}));
  }
  function cartState(cart,items,compositionId) {
    const added=(cart.items||[]).filter(item=>item.properties?._matcha_composition===compositionId);
    if(!added.length)return 'none';
    const counts=new Map();for(const item of added)counts.set(item.variant_id,(counts.get(item.variant_id)||0)+item.quantity);
    return items.length===counts.size && items.every(item=>counts.get(item.id)===item.quantity)?'complete':'partial';
  }
  async function addToCart() {
    if(adding||cartUncertain||!selectionAvailable())return;
    adding=true;renderPricing();byId('cart-feedback').textContent='Vérification de votre composition…';
    byId('review-cart').hidden=true;
    const previousPrice=pricing().totalCents;
    try {
      await refreshProducts(selectedProducts(),true);
      render(false);syncAvailability();
      if(!selectionAvailable()) {
        byId('cart-feedback').textContent='Un composant est épuisé ou sa disponibilité n’a pas pu être vérifiée. Modifiez votre sélection ou rechargez le catalogue.';return;
      }
      if(pricing().totalCents!==previousPrice) {
        byId('cart-feedback').textContent='Les prix ont été actualisés. Vérifiez le nouveau total, puis cliquez à nouveau pour ajouter votre paire.';return;
      }
      const compositionId=crypto.randomUUID();const items=cartItems(compositionId);
      let posted=false;
      // Never retry a POST automatically: a lost response may follow a successful addition.
      try {await jsonRequest(config.cartAddUrl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});posted=true;}catch(_){}
      let cart;
      try {cart=await jsonRequest(apiRoot+'cart.js');}catch(_) {
        cartUncertain=true;byId('cart-feedback').textContent='Le résultat de l’ajout n’a pas pu être vérifié. Ouvrez votre panier pour vérifier votre composition.';
        byId('review-cart').hidden=false;return;
      }
      const result=cartState(cart,items,compositionId);
      if(result==='complete') {cartUncertain=true;byId('cart-feedback').textContent='Votre paire est ajoutée. Ouverture du panier…';location.assign(cartUrl());return;}
      if(result==='partial') {
        cartUncertain=true;byId('cart-feedback').textContent='Votre composition a été ajoutée en partie. Ouvrez votre panier pour vérifier les quantités avant de commander.';
        byId('review-cart').hidden=false;return;
      }
      byId('cart-feedback').textContent=posted?'Votre composition n’a pas été retrouvée dans le panier. Vous pouvez réessayer.':'L’ajout a échoué. Votre composition n’a pas été ajoutée. Vous pouvez réessayer.';
    } catch(_) {byId('cart-feedback').textContent='La vérification a échoué. Rechargez le catalogue avant de réessayer.';}
    finally {adding=false;renderPricing();}
  }
  function syncAvailability() {
    for(const input of root.querySelectorAll('input[name="pair-mode"]')) {
      const sizes=input.value.split('-').map(Number);input.disabled=sizes.some(size=>!catalog.bases[`${size}-${state.finish}`].available);
    }
    for(const input of root.querySelectorAll('input[name="finish"]'))input.disabled=['left','right'].some(ear=>!catalog.bases[`${diameterFor(ear)}-${input.value}`].available);
    for(const input of byId('elements-controls').querySelectorAll('input')) {
      const product=elementsById.get(input.dataset.element),quantity=state.elements[input.dataset.ear][product.id]||0;
      input.disabled=!product.available&&quantity===0;input.max=String(product.available?99:quantity);
    }
    byId('enable-kit').disabled=!catalog.kitDivine.available&&!state.kit.enabled;
    byId('kit-placement').disabled=!state.kit.enabled||!catalog.kitDivine.available;
    for(const product of catalog.elements)byId('elements-controls').querySelector(`[data-price="${product.id}"]`).textContent=product.available?`${money(product.priceCents)} / pièce`:'Indisponible';
    byId('kit-price').textContent=catalog.kitDivine.available?`${money(catalog.kitDivine.priceCents)} / kit`:'Kit indisponible';
  }
  const getSelection = () => ({
    leftDiameterMm:diameterFor('left'), rightDiameterMm:diameterFor('right'), finish:state.finish,
    hoops:['left','right'].map(ear=>({ear,diameterMm:diameterFor(ear),finish:state.finish,quantity:1})),
    leftCharm:{id:state.left,name:charmsById.get(state.left).fullName,quantity:1},
    rightCharm:{id:state.right,name:charmsById.get(state.right).fullName,quantity:1},
    leftElements:selectedElements('left'), rightElements:selectedElements('right'),
    kitDivine:state.kit.enabled ? {id:catalog.kitDivine.id,name:catalog.kitDivine.name,quantity:1,placement:state.kit.placement,finish:'gold'} : null,
    hoopQuantity:2, checks:[], catalogCapturedAt:catalog.capturedAt,
    exactHoopImagesAvailable:['left','right'].every(ear=>Boolean(catalog.bases[baseKey(ear)])),
    elementsCapturedAt:catalog.elementsCapturedAt,
    pricing:pricing(), cartUrl:cartUrl(),
    previewMode:'Photographies séparées des composants, sans simulation d’assemblage ni d’échelle.',
  });
  function photoData(src) {
    if(photoRequests.has(src))return photoRequests.get(src);
    const request=(async()=>{
      const response=await fetch(config.photos[src],{signal:lifecycle.signal});
      if(!response.ok)throw new Error('Photo indisponible.');
      const data=await response.json();
      if(!['image/png','image/jpeg'].includes(data.mimeType)||typeof data.base64!=='string'||!data.base64)throw new Error('Photo invalide.');
      return `data:${data.mimeType};base64,${data.base64}`;
    })();
    photoRequests.set(src,request);
    request.catch(()=>{if(photoRequests.get(src)===request)photoRequests.delete(src);});
    return request;
  }
  function clearPhotoError(img) {
    img.hidden=false;delete img.dataset.errorShown;
    img._photoError?.remove();img._photoError=null;
    updatePhotoRetry();
  }
  function updatePhotoRetry() {
    const hasError=Boolean(root.querySelector('img[data-error-shown="true"]'));
    for(const id of ['retry-photos','picker-retry-photos'])byId(id).hidden=!hasError;
  }
  function retryPhotos() {
    const images=[...root.querySelectorAll('img[data-error-shown="true"]')];
    for(const src of new Set(images.map(img=>img.dataset.photoPath)))photoRequests.delete(src);
    for(const img of images)loadPhoto(img,img.dataset.photoPath,img.alt,true);
    (byId('charm-picker').open?byId('picker-title'):byId('choose-left')).focus({preventScroll:true});
  }
  function showPhotoError(img) {
    if(!img.isConnected||img.dataset.errorShown)return;
    img.dataset.errorShown='true';img.hidden=true;
    const note=document.createElement('span');note.className='image-error';
    const label=document.createElement('span');label.textContent='Photo indisponible';
    note.append(label);img._photoError=note;img.parentElement.append(note);updatePhotoRetry();
  }
  function loadPhoto(img,src,alt,force=false) {
    img.alt=alt;
    if(!force&&img.dataset.photoPath===src&&!img.dataset.errorShown)return;
    img.dataset.photoPath=src;clearPhotoError(img);img.removeAttribute('src');
    const current={};img._photoLoad=current;
    (async()=>{
      for(let attempt=0;attempt<2;attempt++){
        try{
          const data=await photoData(src);
          if(img._photoLoad!==current)return;
          img.src=data;await img.decode();
          if(img._photoLoad===current)clearPhotoError(img);
          return;
        }catch(_){
          if(img._photoLoad!==current)return;
          photoRequests.delete(src);
          if(attempt===1){showPhotoError(img);return;}
          await new Promise(resolve=>setTimeout(resolve,250));
        }
      }
    })();
  }
  const setImage = (id,src,alt) => loadPhoto(byId(id),src,alt);
  function render(announce=true) {
    byId('base-badge').textContent = `${state.leftDiameter===state.rightDiameter?'2 × '+state.leftDiameter:'25 + 40'} mm · ${finishName()}`;
    for (const ear of ['left','right']) {
      const base = catalog.bases[baseKey(ear)];
      const diameter = diameterFor(ear);
      const charm = charmsById.get(state[ear]);
      setImage(`${ear}-base-image`,base.image,base.name);
      byId(`${ear}-ear-label`).textContent = `${ear === 'left' ? 'Gauche' : 'Droite'} · ${diameter} mm`;
      byId(`${ear}-selected-name`).textContent = charm.name;
      byId(`${ear}-choice-ear`).textContent = `${ear==='left'?'Gauche':'Droite'} · ${diameter} mm`;
      byId(`choose-${ear}`).setAttribute('aria-label',`Changer la breloque à ${ear==='left'?'gauche':'droite'} : ${charm.fullName}`);
      setImage(`${ear}-preview`,charm.image,charm.fullName);
      setImage(`${ear}-thumb`,charm.image,'');
      byId(`${ear}-preview-name`).textContent = charm.name;
      byId(`${ear}-charm-price`).textContent = `${money(charm.priceCents)} · à la pièce`;
      byId(`summary-${ear}`).textContent = `${diameter} mm · ${charm.name}${elementText(ear) ? ' + '+elementText(ear) : ''}`;
      renderElementsPreview(ear);
    }
    root.querySelector(`input[name="pair-mode"][value="${pairMode()}"]`).checked = true;
    byId('swap-sides').hidden=state.leftDiameter===state.rightDiameter;
    for(const [mode,sizes] of [['25-25',[25,25]],['40-40',[40,40]],['25-40',[25,40]]])byId(`pair-price-${mode}`).textContent=sizes.every(size=>catalog.bases[`${size}-${state.finish}`].available)?money(sizes.reduce((n,size)=>n+catalog.bases[`${size}-${state.finish}`].priceCents,0)):'Indisponible';
    root.querySelector(`input[name="finish"][value="${state.finish}"]`).checked = true;
    byId('summary-base').textContent = `${pairText()} · ${finishName()}`;
    const count=elementCount();
    byId('summary-status').textContent = `2 créoles + 2 breloques${count ? ` + ${count} élément${count>1?'s':''}` : ''}${state.kit.enabled ? ' + 1 kit Divine' : ''}. `;
    for (const input of byId('elements-controls').querySelectorAll('input')) input.value=String(state.elements[input.dataset.ear][input.dataset.element] || 0);
    byId('enable-kit').checked=state.kit.enabled;
    byId('kit-placement').disabled=!state.kit.enabled;
    byId('kit-placement').value=state.kit.placement;
    byId('kit-preview').hidden=!state.kit.enabled;
    byId('summary-kit-row').hidden=!state.kit.enabled;
    byId('kit-allocation-label').textContent=kitPlacementName();
    byId('summary-kit').textContent=`1 kit Divine doré · ${kitPlacementName()}`;
    renderPricing();
    if(byId('charm-picker').open) renderPicker();
    if (announce) byId('selection-announcement').textContent = `Paire mise à jour : finition ${finishName()}, gauche ${diameterFor('left')} mm avec ${charmsById.get(state.left).name}, droite ${diameterFor('right')} mm avec ${charmsById.get(state.right).name}. ${count} éléments supplémentaires${state.kit.enabled ? ', un kit Divine' : ''}. Total hors livraison : ${money(pricing().totalCents)}.`;
  }
  function updateStartingPrice() {
    const bases=Object.values(catalog.bases).filter(product=>product.available&&Number.isSafeInteger(product.priceCents));
    const charms=catalog.charms.filter(product=>product.available&&Number.isSafeInteger(product.priceCents));
    byId('starting-price').hidden=!bases.length||!charms.length;
    if(bases.length&&charms.length)byId('starting-price-value').textContent=money(2*Math.min(...bases.map(product=>product.priceCents))+2*Math.min(...charms.map(product=>product.priceCents)));
  }
  function setCreationStep(step) {
    for(const button of root.querySelectorAll('[data-creation-step]')) {
      if(Number(button.dataset.creationStep)===step)button.setAttribute('aria-current','step');
      else button.removeAttribute('aria-current');
    }
    byId('creation-progress-bar').value=step;
    byId('creation-progress-label').textContent=`Étape ${step} sur 3 · ${['Vos créoles','Breloques et charms','Votre paire'][step-1]}`;
    byId('creation-step-help').textContent=['Choisissez les diamètres et la finition.','Choisissez une breloque par oreille. Charms et kit Divine sont facultatifs.','Vérifiez votre composition et le total, puis ajoutez votre paire au panier.'][step-1];
  }
  function initCreationGuide() {
    for(const button of root.querySelectorAll('[data-creation-step]'))button.addEventListener('click',()=>{
      const step=Number(button.dataset.creationStep),target=byId('creation-step-'+step);
      setCreationStep(step);target.focus({preventScroll:true});
      target.scrollIntoView({block:'start',inline:'nearest',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    });
    for(const step of [1,2,3])byId('creation-step-'+step).addEventListener('focusin',()=>setCreationStep(step));
    byId('elements-picker').addEventListener('toggle',()=>{if(byId('elements-picker').open)setCreationStep(2);});
    byId('mobile-add-to-cart').addEventListener('click',()=>setCreationStep(3));
    setCreationStep(1);byId('creation-guide').hidden=false;
  }
  function renderPricing() {
    updateStartingPrice();
    const price=pricing();
    byId('selection-total').textContent=money(price.totalCents);
    byId('mobile-selection-total').textContent=money(price.totalCents);
    for(const id of ['add-to-cart','mobile-add-to-cart'])byId(id).disabled=adding||cartUncertain||!selectionAvailable();
    byId('review-cart').href=cartUrl();
    for(const selector of ['.controls-base','.controls-charms'])root.querySelector(selector).inert=adding;
    for(const button of root.querySelectorAll('[data-creation-step]'))button.disabled=adding;
    const container=byId('price-lines');container.replaceChildren();
    for(const line of price.lines) {
      const row=document.createElement('li');
      const label=document.createElement('span');label.textContent=`${line.name} × ${line.quantity}`;
      const total=document.createElement('strong');total.textContent=money(line.totalPriceCents);
      row.append(label,total);container.append(row);
    }
  }
  function renderElementsPreview(ear) {
    const container=byId(`${ear}-elements-preview`);
    const items=selectedElements(ear);
    container.replaceChildren();container.hidden=!items.length;
    for (const item of items) {
      const card=document.createElement('div');card.className='element-preview-card';
      const img=document.createElement('img');img.width=120;img.height=120;loadPhoto(img,item.image,item.name);
      const label=document.createElement('span');label.textContent=`${item.name} × ${item.quantity}`;
      card.append(img,label);container.append(card);
    }
  }
  function openPicker(ear) {
    state.target=ear;picker.theme=null;picker.query='';picker.page=0;
    byId('charm-search').value='';pickerOpener=byId(`choose-${ear}`);
    renderPicker();byId('charm-picker').showModal();
    savedOverflow=document.body.style.overflow;document.body.style.overflow='hidden';byId('picker-body').scrollTop=0;
    byId('picker-title').focus({preventScroll:true});
  }
  function resetPicker() {
    picker.theme=null;picker.query='';picker.page=0;byId('charm-search').value='';
    renderPicker();byId('picker-body').scrollTop=0;byId('theme-title').focus({preventScroll:true});
  }
  function chooseTheme(id) {
    picker.theme=id;picker.query='';picker.page=0;byId('charm-search').value='';
    renderPicker();byId('picker-body').scrollTop=0;byId('picker-view-title').focus({preventScroll:true});
  }
  function matchingCharms() {
    const query=normalize(picker.query);const terms=query.split(/\s+/).filter(Boolean);
    const rank=charm=>{const name=normalize(charm.name);return name===query?0:name.startsWith(query)?1:2;};
    return catalog.charms.filter(charm=>{
      if(!terms.length && picker.theme && picker.theme!=='all' && !charm.themeIds.includes(picker.theme)) return false;
      const text=normalize(`${charm.name} ${charm.fullName} ${catalog.themes.filter(t=>charm.themeIds.includes(t.id)).map(t=>t.name).join(' ')}`);
      return terms.every(term=>text.includes(term));
    }).sort((a,b)=>(query?rank(a)-rank(b):0)||a.name.localeCompare(b.name,'fr'));
  }
  function renderPicker() {
    byId('picker-ear').textContent=`Oreille ${state.target==='left'?'gauche':'droite'} · ${diameterFor(state.target)} mm`;
    const overview=picker.theme===null && !picker.query.trim();
    byId('theme-overview').hidden=!overview;byId('picker-results').hidden=overview;
    byId('clear-search').hidden=!picker.query;
    const grid=byId('picker-grid');grid.replaceChildren();
    if(overview) {byId('picker-count').textContent='';return;}
    const matches=matchingCharms();const total=matches.length;const pageCount=Math.ceil(total/pageSize);
    picker.page=Math.min(picker.page,Math.max(0,pageCount-1));
    byId('picker-view-title').textContent=picker.query.trim()?`Résultats pour « ${picker.query.trim()} »`:(picker.theme==='all'?'Toutes les breloques':catalog.themes.find(t=>t.id===picker.theme).name);
    const start=picker.page*pageSize;
    byId('picker-count').textContent=total?`${total} breloque${total>1?'s':''} · ${start+1}–${Math.min(start+pageSize,total)} affichées`:'Aucun résultat';
    byId('picker-empty').hidden=total>0;
    for(const charm of matches.slice(start,start+pageSize)) {
      const button=document.createElement('button');button.type='button';button.className='picker-product';button.dataset.charm=charm.id;
      const selected=state[state.target]===charm.id;
      button.setAttribute('aria-pressed',String(selected));
      button.setAttribute('aria-label',`Choisir ${charm.fullName}, ${money(charm.priceCents)}, pour l’oreille ${state.target==='left'?'gauche':'droite'}`);
      button.disabled=!charm.available;
      const photo=document.createElement('img');photo.width=200;photo.height=200;loadPhoto(photo,charm.image,'');
      const name=document.createElement('strong');name.textContent=charm.name;
      const price=document.createElement('span');price.className='picker-price';price.textContent=money(charm.priceCents);
      const mark=document.createElement('span');mark.className='picker-selection';
      if(!charm.available){mark.textContent=charm.connectionError?'Indisponible':'Épuisée';mark.classList.add('unavailable');}else if(selected) mark.textContent='Choisie';else if(state[state.target==='left'?'right':'left']===charm.id) mark.textContent=state.target==='left'?'À droite':'À gauche';
      mark.hidden=!mark.textContent;button.append(photo,name,price,mark);
      button.addEventListener('click',()=>{byId('charm-picker').close();configure({[`${state.target}CharmId`]:charm.id});});
      grid.append(button);
    }
    byId('picker-pagination').hidden=pageCount<=1;
    byId('picker-previous').disabled=picker.page===0;byId('picker-next').disabled=picker.page>=pageCount-1;
    byId('picker-page').textContent=`${picker.page+1} / ${pageCount}`;
  }
  function initPicker() {
    const dialog=byId('charm-picker');
    for(const ear of ['left','right']) byId(`choose-${ear}`).addEventListener('click',()=>openPicker(ear));
    byId('close-picker').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('keydown',event=>{
      if(event.key==='Escape'){event.preventDefault();dialog.close();return;}
      if(event.key!=='Tab')return;
      const controls=[...dialog.querySelectorAll('button,input,select,textarea,a[href],[tabindex="0"]')].filter(element=>!element.disabled&&element.getClientRects().length);
      const first=controls[0],last=controls[controls.length-1];
      if(event.shiftKey&&(root.activeElement===first||root.activeElement===byId('picker-title'))){event.preventDefault();last?.focus();}
      else if(!event.shiftKey&&root.activeElement===last){event.preventDefault();first?.focus();}
    });
    dialog.addEventListener('close',()=>{document.body.style.overflow=savedOverflow ?? '';savedOverflow=undefined;pickerOpener?.focus({preventScroll:true});});
    dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();});
    byId('charm-search').addEventListener('input',event=>{picker.query=event.target.value;picker.page=0;renderPicker();});
    byId('clear-search').addEventListener('click',()=>{picker.query='';byId('charm-search').value='';picker.page=0;renderPicker();byId('charm-search').focus();});
    byId('picker-back').addEventListener('click',resetPicker);
    byId('browse-all').addEventListener('click',()=>chooseTheme('all'));
    for(const [id,delta] of [['picker-previous',-1],['picker-next',1]]) byId(id).addEventListener('click',()=>{picker.page+=delta;renderPicker();byId('picker-body').scrollTop=0;byId('picker-view-title').focus({preventScroll:true});});
    for(const theme of catalog.themes) {
      const charms=catalog.charms.filter(c=>c.themeIds.includes(theme.id));
      const button=document.createElement('button');button.type='button';button.className='theme-card';button.dataset.theme=theme.id;
      const photo=document.createElement('img');photo.width=80;photo.height=80;loadPhoto(photo,(charms.find(c=>c.available)||charms[0]).image,'');
      const text=document.createElement('span');const name=document.createElement('strong');name.textContent=theme.name;
      const count=document.createElement('small');count.textContent=`${charms.filter(c=>c.available).length} disponibles`;text.append(name,count);button.append(photo,text);
      button.addEventListener('click',()=>chooseTheme(theme.id));byId('theme-grid').append(button);
    }
    byId('browse-all').textContent=`Voir toutes les breloques (${catalog.charms.length})`;
  }
  function configure(input) {
    if (!input || typeof input !== 'object' || Array.isArray(input)) throw new Error('Sélection invalide.');
    const allowed = ['leftDiameterMm','rightDiameterMm','finish','leftCharmId','rightCharmId','leftElements','rightElements','kitDivine'];
    if (Object.keys(input).some(k => !allowed.includes(k)) || !Object.keys(input).length) throw new Error('Champ de sélection invalide.');
    for (const field of ['leftDiameterMm','rightDiameterMm']) if (field in input && ![25,40].includes(input[field])) throw new Error('Diamètre invalide.');
    if ('finish' in input && !['gold','silver'].includes(input.finish)) throw new Error('Finition invalide.');
    for (const field of ['leftCharmId','rightCharmId']) if (field in input && !charmsById.has(input[field])) throw new Error('Breloque absente du catalogue.');
    for(const field of ['leftCharmId','rightCharmId'])if(field in input&&!charmsById.get(input[field]).available)throw new Error('Breloque indisponible.');
    const nextElements={};
    for (const ear of ['left','right']) if (`${ear}Elements` in input) {
      const items=input[`${ear}Elements`];
      if (!Array.isArray(items)) throw new Error('Liste d’éléments invalide.');
      const quantities={};const ids=new Set();
      for (const item of items) {
        if (!item || typeof item!=='object' || Array.isArray(item) || Object.keys(item).some(key=>!['id','quantity'].includes(key)) || !elementsById.has(item.id) || !Number.isInteger(item.quantity) || item.quantity<0 || item.quantity>99 || ids.has(item.id)) throw new Error('Élément ou quantité invalide.');
        ids.add(item.id);if (item.quantity>0) quantities[item.id]=item.quantity;
      }
      nextElements[ear]=quantities;
    }
    if ('kitDivine' in input) {
      const kit=input.kitDivine;
      if (!kit || typeof kit!=='object' || Array.isArray(kit) || Object.keys(kit).some(key=>!['enabled','placement'].includes(key)) || typeof kit.enabled!=='boolean' || ('placement' in kit && !['both','left','right'].includes(kit.placement))) throw new Error('Choix du kit invalide.');
    }
    if(adding)throw new Error('Ajout en cours.');
    if ('leftDiameterMm' in input) state.leftDiameter = input.leftDiameterMm;
    if ('rightDiameterMm' in input) state.rightDiameter = input.rightDiameterMm;
    if ('finish' in input) state.finish = input.finish;
    if ('leftCharmId' in input) state.left = input.leftCharmId;
    if ('rightCharmId' in input) state.right = input.rightCharmId;
    for (const ear of ['left','right']) if (ear in nextElements) state.elements[ear]=nextElements[ear];
    if ('kitDivine' in input) state.kit={enabled:input.kitDivine.enabled,placement:input.kitDivine.placement ?? state.kit.placement};
    byId('cart-feedback').textContent='';
    render();syncAvailability();
    return getSelection();
  }
  function registerTools() {
    const context = document.modelContext;
    if (!context?.registerTool) return;
    const tools = [
      {name:'read_matcha_catalog',title:'Lire le catalogue Matcha',description:'Lire les composants, thèmes, prix et choix de paire du configurateur : 2 créoles de 25 mm, 2 de 40 mm ou une de chaque.',inputSchema:{type:'object',properties:{},additionalProperties:false},annotations:{readOnlyHint:true,untrustedContentHint:false},execute:() => ({diametersMm:[25,40],pairCompositionsMm:catalog.pairCompositionsMm,finishes:['gold','silver'],bases:catalog.bases,themes:catalog.themes,charms:catalog.charms.map(c=>({id:c.id,name:c.fullName,themeIds:c.themeIds,priceCents:c.priceCents,variantId:c.variantId})),elements:catalog.elements.map(e=>({id:e.id,name:e.name,priceCents:e.priceCents,variantId:e.variantId})),kitDivine:{id:catalog.kitDivine.id,name:catalog.kitDivine.name,finish:'gold',priceCents:catalog.kitDivine.priceCents,variantId:catalog.kitDivine.variantId},commerce:catalog.commerce,capturedAt:catalog.capturedAt,elementsCapturedAt:catalog.elementsCapturedAt})},
      {name:'read_matcha_selection',title:'Lire la composition',description:'Lire la sélection visible, ses composants et les vérifications encore nécessaires.',inputSchema:{type:'object',properties:{},additionalProperties:false},annotations:{readOnlyHint:true,untrustedContentHint:false},execute:getSelection},
      {name:'configure_matcha_pair',title:'Composer une paire Matcha',description:'Choisir indépendamment les diamètres 25 ou 40 mm, les breloques et les listes d’éléments de chaque oreille (id et quantité). Ajouter un kit Divine doré et sa répartition. Retourner le total et le lien de panier sans ouvrir le panier, transmettre la sélection ou passer commande.',inputSchema:{type:'object',properties:{leftDiameterMm:{type:'integer',enum:[25,40]},rightDiameterMm:{type:'integer',enum:[25,40]},finish:{type:'string',enum:['gold','silver']},leftCharmId:{type:'string'},rightCharmId:{type:'string'},leftElements:{type:'array',items:{type:'object',properties:{id:{type:'string'},quantity:{type:'integer',minimum:0,maximum:99}},required:['id','quantity'],additionalProperties:false}},rightElements:{type:'array',items:{type:'object',properties:{id:{type:'string'},quantity:{type:'integer',minimum:0,maximum:99}},required:['id','quantity'],additionalProperties:false}},kitDivine:{type:'object',properties:{enabled:{type:'boolean'},placement:{type:'string',enum:['both','left','right']}},required:['enabled'],additionalProperties:false}},minProperties:1,additionalProperties:false},annotations:{readOnlyHint:false,untrustedContentHint:false},execute:configure}
    ];
    for (const tool of tools) try {Promise.resolve(context.registerTool(tool,{signal:lifecycle.signal})).catch(()=>{});} catch (_) {}
    
  }
  async function init() {
    try {
      const response = await fetch(config.catalogUrl,{signal:lifecycle.signal});
      if (!response.ok) throw new Error('Catalogue indisponible.');
      catalog = await response.json();
      if (!Array.isArray(catalog.charms) || catalog.charms.length < 2 || !Array.isArray(catalog.elements) || !catalog.kitDivine || !catalog.bases || ['25-gold','25-silver','40-gold','40-silver'].some(key=>!catalog.bases[key])) throw new Error('Catalogue incomplet.');
      if(allProducts().some(product=>!Number.isSafeInteger(product.variantId)||product.variantId<=0||!product.handle||!config.photos[product.image]))throw new Error('Catalogue incomplet.');
      byId('reload-catalog').addEventListener('click',()=>location.reload());
      // Prix, disponibilités et devise fournis par Shopify dans la page (sections/matcha-live.liquid) :
      // seuls les composants qui n’y figurent pas sont demandés un par un.
      let live={};
      try {live=JSON.parse(document.querySelector('script[data-matcha-live]')?.textContent||'{}')||{};}catch(_){}
      const pending=allProducts().filter(product=>{
        const variant=live.variants?.[product.variantId];
        if(!variant||!Number.isSafeInteger(variant.price)||variant.price<0)return true;
        product.priceCents=variant.price;product.available=variant.available===true;product.connectionError=false;
        return false;
      });
      const currencyRequest=/^[A-Z]{3}$/.test(live.currency)?{currency:live.currency}:jsonRequest(apiRoot+'cart.js').catch(()=>null);
      await refreshProducts(pending,false,(done,total)=>{byId('loading').textContent=`Ouverture du studio · ${done} / ${total} composants vérifiés…`;});
      const initialCart=await currencyRequest;
      if(!initialCart||!/^[A-Z]{3}$/.test(initialCart.currency))throw new Error('Devise indisponible.');
      catalog.commerce.currency=initialCart.currency;catalog.commerce.capturedAt=new Date().toISOString();

      if(!Array.isArray(catalog.themes)||!catalog.themes.length||catalog.themes.some(t=>!catalog.charms.some(c=>c.themeIds?.includes(t.id)))||catalog.charms.some(c=>!c.themeIds?.length||c.themeIds.some(id=>!catalog.themes.some(t=>t.id===id)))) throw new Error('Thèmes incomplets.');
      catalog.charms.forEach(c => charmsById.set(c.id,c));
      catalog.elements.forEach(e=>elementsById.set(e.id,e));
      const available=catalog.charms.filter(charm=>charm.available);
      if(!available.length)throw new Error('Aucune breloque disponible.');
      state.left=available[0].id;state.right=(available[1]||available[0]).id;
      const choices=['gold','silver'].flatMap(finish=>[[25,40],[25,25],[40,40]].map(sizes=>({finish,sizes})));
      const first=choices.find(choice=>choice.sizes.every(size=>catalog.bases[`${size}-${choice.finish}`].available));
      if(!first)throw new Error('Créoles indisponibles.');
      state.finish=first.finish;[state.leftDiameter,state.rightDiameter]=first.sizes;
      initPicker();initCreationGuide();
      for (const input of root.querySelectorAll('input[name="pair-mode"]')) input.addEventListener('change',e=>{const [leftDiameterMm,rightDiameterMm]=e.target.value.split('-').map(Number);configure({leftDiameterMm,rightDiameterMm});});
      byId('swap-sides').addEventListener('click',()=>configure({leftDiameterMm:state.rightDiameter,rightDiameterMm:state.leftDiameter}));
      for (const input of root.querySelectorAll('input[name="finish"]')) input.addEventListener('change',e=>configure({finish:e.target.value}));
      catalog.elements.forEach(element=>{
        const row=document.createElement('div');row.className='element-control-row';
        const description=document.createElement('div');description.className='element-description';
        const img=document.createElement('img');img.alt='';img.width=56;img.height=56;img.dataset.pendingPhoto=element.image;
        const text=document.createElement('div');
        const name=document.createElement('strong');name.textContent=element.name;
        const price=document.createElement('span');price.className='unit-price';price.dataset.price=element.id;price.textContent=`${money(element.priceCents)} / pièce`;text.append(name,price);description.append(img,text);
        const group=document.createElement('div');group.className='element-quantities';
        for (const ear of ['left','right']) {
          const label=document.createElement('label');label.className='quantity-field';
          const title=document.createElement('span');title.textContent=ear==='left'?'Gauche':'Droite';
          const input=document.createElement('input');input.type='number';input.min='0';input.max='99';input.step='1';input.value='0';input.inputMode='numeric';input.dataset.ear=ear;input.dataset.element=element.id;input.setAttribute('aria-label',`${element.name} : quantité à ${ear==='left'?'gauche':'droite'}`);
          input.addEventListener('change',()=>{
            if (!input.checkValidity()){input.reportValidity();input.value=String(state.elements[ear][element.id] || 0);return;}
            const quantities={...state.elements[ear],[element.id]:Number(input.value)};
            configure({[`${ear}Elements`]:Object.entries(quantities).map(([id,quantity])=>({id,quantity}))});
          });
          label.append(title,input);group.append(label);
        }
        row.append(description,group);byId('elements-controls').append(row);
      });
      byId('elements-picker').addEventListener('toggle',()=>{
        if(!byId('elements-picker').open)return;
        for(const img of byId('elements-controls').querySelectorAll('img[data-pending-photo]')){
          const src=img.dataset.pendingPhoto;delete img.dataset.pendingPhoto;loadPhoto(img,src,'');
        }
      });
      setImage('kit-image',catalog.kitDivine.image,'Kit Divine : photo du kit complet');setImage('kit-thumb',catalog.kitDivine.image,'');
      byId('kit-price').textContent=`${money(catalog.kitDivine.priceCents)} / kit`;
      byId('enable-kit').addEventListener('change',e=>configure({kitDivine:{enabled:e.target.checked}}));
      byId('kit-placement').addEventListener('change',e=>configure({kitDivine:{enabled:state.kit.enabled,placement:e.target.value}}));
      byId('elements-count').textContent=`${catalog.elements.length+1} éléments`;
      byId('elements-source-note').textContent="Le kit est présenté entier, sans simulation de sa répartition.";
      byId('catalog-count').textContent=`${catalog.charms.length} breloques`;
      byId('catalog-note').textContent="Disponibilités vérifiées dans Shopify à l’ouverture du studio. Les produits épuisés ne peuvent pas être sélectionnés.";
      byId('price-note').textContent="Prix lus dans Shopify, hors livraison et remises. La disponibilité et les prix sont vérifiés à nouveau avant l’ajout au panier.";
      for(const id of ['retry-photos','picker-retry-photos'])byId(id).addEventListener('click',retryPhotos);
      render(false);syncAvailability();
      for(const id of ['add-to-cart','mobile-add-to-cart'])byId(id).addEventListener('click',addToCart);
      byId('loading').hidden=true;byId('workspace').hidden=false;
      byId('mobile-cart-bar').hidden=false;
      mobileObserver=new ResizeObserver(()=>host.style.setProperty('--mobile-cart-height',`${byId('mobile-cart-bar').getBoundingClientRect().height}px`)).observe(byId('mobile-cart-bar'));
      const previewBar=document.getElementById('preview-bar-iframe');
      if(previewBar)host.style.setProperty('--matcha-preview-bottom',`${previewBar.getBoundingClientRect().height}px`);
      registerTools();
    } catch (_) {
      byId('loading').hidden=true;byId('load-error').hidden=false;
    }
  }
  init();
  return ()=>{lifecycle.abort();mobileObserver?.disconnect();if(savedOverflow!==undefined)document.body.style.overflow=savedOverflow;};
}
class MatchaConfigurator extends HTMLElement {
  connectedCallback() {
    if(this.shadowRoot)return;
    const template=this.querySelector('template');const settings=this.querySelector('[data-matcha-config]');
    if(!template||!settings)return;
    const root=this.attachShadow({mode:'open'});root.append(template.content.cloneNode(true));
    try {this._matchaDispose=startMatcha(this,root,JSON.parse(settings.textContent));}catch(_){root.getElementById('loading').hidden=true;root.getElementById('load-error').hidden=false;}
  }
  disconnectedCallback(){this._matchaDispose?.();}
}
if(!customElements.get('matcha-configurator'))customElements.define('matcha-configurator',MatchaConfigurator);
